import { render, staticRenderFns } from "./RedPackModel.vue?vue&type=template&id=2fb928ae&scoped=true"
import script from "./RedPackModel.vue?vue&type=script&lang=js"
export * from "./RedPackModel.vue?vue&type=script&lang=js"
import style0 from "./RedPackModel.vue?vue&type=style&index=0&id=2fb928ae&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb928ae",
  null
  
)

export default component.exports